var map = {
	"./MainProjects/AlgorithmVisualizer.png": 6268,
	"./MainProjects/AlgorithmVisualizer.webp": 7873,
	"./MainProjects/DjangoBlog.png": 3000,
	"./MainProjects/DjangoBlog.webp": 4971,
	"./MainProjects/GameInUnity.png": 8076,
	"./MainProjects/GameInUnity.webp": 6944,
	"./MainProjects/LookUp.png": 470,
	"./MainProjects/LookUp.webp": 9360,
	"./MainProjects/MazeGenerator.png": 8231,
	"./MainProjects/MazeGenerator.webp": 6064,
	"./MainProjects/SudokuGame.png": 4205,
	"./MainProjects/SudokuGame.webp": 5503,
	"./MainProjects/TypingMultiplayer.png": 5549,
	"./MainProjects/TypingMultiplayer.webp": 7218,
	"./MainProjects/cpp_server.png": 1723,
	"./MainProjects/cpp_server.webp": 609,
	"./MainProjects/interview_experience.png": 6594,
	"./MainProjects/interview_experience.webp": 7522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;